module.exports = __webpack_public_path__ + "static/media/metacognition-large@3x.c0ffe690.png";